import React from "react";
import { isBrowser } from "react-device-detect";
import { useDispatch } from "react-redux";
import {
  openAcceptLabOrderModal,
  openRejectLabOrderModal,
} from "../../../../../redux/actions/modals";
import SafeCallComponent from "../LabOrderItem/children/SafeCallComponent";
const LabOrderWaitingForPriceActions = (props) => {
  const dispatch = useDispatch();
  console.log("actin", props.order)
  return (
    <>
      <div className={isBrowser ? "flex-column waiting-for-price-buttons" : "flex-column waiting-for-price-buttons-mobile"}>
        <button
          className="btn btn-small btn-success btn-accept margin-bottom-5"
          onClick={() => {
            dispatch(openAcceptLabOrderModal(props.order));
          }}
        >
          قبول سفارش و اعلام هزینه
        </button>
        <SafeCallComponent order={props.order} />
        <button
          className="btn btn-small btn-outline-black margin-bottom-5"
          onClick={() => {
            dispatch(openRejectLabOrderModal(props.order));
          }}
        >
          رد سفارش
        </button>
      </div>
    </>
  );
};

export default LabOrderWaitingForPriceActions;
